import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import DashboardIcon from '@material-ui/icons/Dashboard';

import PeopleIcon from '@material-ui/icons/People';
import BarChartIcon from '@material-ui/icons/BarChart';
import LayersIcon from '@material-ui/icons/Layers';
import AssignmentIcon from '@material-ui/icons/Assignment';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
//import Link from '@material-ui/core/Link';
import { Link } from "react-router-dom";
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';




export const mainListItems = (
	<div>
		<ListItem button
			component={Link}
			to="/"
		>
			<ListItemIcon>
				<DashboardIcon />
			</ListItemIcon>
			<ListItemText primary="DASHBOARD" />
			
		</ListItem>
		<ListItem button
			component={Link}
			to='/assets'
		>
			<ListItemIcon>
				<AccountBalanceIcon />
			</ListItemIcon>
			<ListItemText primary="ASSETS" />
		</ListItem>
		<ListItem button
			component={Link}
			to='/famas'
		>
			<ListItemIcon>
				<LibraryBooksIcon />
			</ListItemIcon>
			<ListItemText primary="FAMAS" />
		</ListItem>
		
	</div>
);

export const adminListItems = (

	<div>
		<ListItem button
			component={Link}
			to='/people'
		>
			<ListItemIcon>
				<PeopleIcon />
			</ListItemIcon>
			<ListItemText primary="PEOPLE" />
		</ListItem>
		<ListItem button 
			component={Link}
			to='/tools'
		>
			<ListItemIcon>
				<BarChartIcon />
			</ListItemIcon>
			<ListItemText primary="TOOLS" />
		</ListItem>
		<ListItem button
			component={Link}
			to='/users'
		>
			<ListItemIcon>
				<LayersIcon />
			</ListItemIcon>
			<ListItemText primary="USERS" />
		</ListItem>
		<ListItem button
			component={Link}
			to='/qr'
		>
			<ListItemIcon>
				<LayersIcon />
			</ListItemIcon>
			<ListItemText primary="QR" />
		</ListItem>
	</div>

)

export const secondaryListItems = (
	<div>
		<ListSubheader inset>REPORTS</ListSubheader>
		<ListItem button
			component={Link}
			to='/reports/overall' >
			<ListItemIcon>
				<AssignmentIcon />
			</ListItemIcon>
			<ListItemText primary="Summary Report" />
		</ListItem>
		<ListItem button
			component={Link}
			to='/reports/query' >
			
			<ListItemIcon>
				<AssignmentIcon />
			</ListItemIcon>
			<ListItemText primary="Query Report" />
		</ListItem>
		<ListItem button
			component={Link}
			to='/reports/approval'>
			<ListItemIcon>
				<AssignmentIcon />
			</ListItemIcon>
			<ListItemText primary="For Approval" />
		</ListItem>
	</div>
);
